<template>
  <div class="consumer-success">
    <div class="row success-instructions" v-if="consumerLoaded">
      <div class="col-12" v-if="submits.length > 0">
        <h2>What's next?</h2>
        <ul>
          <li>
            A representative from each school listed will contact you.
          </li>
          <li>
            They will provide information about the program you're interested in.
          </li>
          <li>
            Choose the school that's right for you!
          </li>
        </ul>
      </div>
      <div class="col-12" v-else>
        No offers submitted.
      </div>
    </div>
    <div class="row success-lists" v-if="consumerLoaded && submits.length > 0">
      <div class="col-4">
        <AcceptedOffers :title="'Accepted Schools'" :is-extra="false"></AcceptedOffers>
      </div>
      <div class="col-4" v-if="hasExtraAccepted">
        <AcceptedOffers :title="'Accepted Extra Offers'" :is-extra="true"></AcceptedOffers>
      </div>
      <div class="col-4">
        <RejectedOffers :title="'Rejected Schools'"></RejectedOffers>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AcceptedOffers from '@/components/offer-minilists/AcceptedOffers.vue'
import RejectedOffers from '@/components/offer-minilists/RejectedOffers.vue'

export default {
  name: 'ConsumerSuccess',
  props: ['consumerId'],
  data () {
    return {
    }
  },
  components: {
    AcceptedOffers,
    RejectedOffers
  },
  methods: {
    load (id) {
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      }
    },
    ...mapActions({
      loadConsumer: 'consumer/retrieveConsumer'
    })
  },
  computed: {
    hasExtraAccepted () {
      return this.submits.some((offer) => offer.status === 'Accepted' && offer.offer.isExtra)
    },
    ...mapState({
      loadedId: state => state.consumer.consumerId
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded',
      submits: 'consumer/leadRequests/getRequests'
    })
  },
  mounted () {
    if (this.consumerId) {
      this.load(this.consumerId)
    }
  },
  watch: {
    consumerId (val) {
      this.load(val)
    }
  }
}
</script>
